import React from "react";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import TeamLeadership from "./TeamLeadership";

const TeamPage: React.FC = () => (
  <div className="about-page inner-page digicomm-team-page">
    <div className="body_wrap o-clip">
      <Header />
      <main>
        <PageTitle pageTitle="Our Leadership" pagesub="Our Leadership" />
        <TeamLeadership />
      </main>
      <Footer />
      <Scrollbar />
    </div>
  </div>
);
export default TeamPage;
